import React from "react";
//@ts-ignore
import { caratIcon } from "@lululemon/ui-icons";
import { Pill, PILL_ICON_POSITION } from "../../atoms";

// Styles
import styles from "./FilterPills.module.scss";

/**
 * Renders a list of filter pills based on the provided filters.
 *
 * @component
 * @param {Object[]} filters - The array of filters to render as filter pills.
 * @param {Function} onClick - The callback function to be called when a filter pill is clicked.
 */

interface FilterPillsProps {
  filters: Facet[];
  onClick: (name: string, trackEventObj: TrackEventObj) => void;
}

export const FilterPills: React.FC<FilterPillsProps> = React.memo(
  ({ filters, onClick }) => {
    return (
      <div className={styles.filterPillsWrapper}>
        {filters?.map((filter, index) => {
          const count = filter?.["selected-count"];
          const name = filter?.name;

          return (
            <div key={index} className={styles.filterPillsWrapper_bttn}>
              <Pill
                icon={caratIcon}
                onClick={({ text }) =>
                  // index is 0 based, so we add 1 for the position
                  onClick(name, {
                    position: index + 1,
                    totalCount: filters.length,
                    text: text,
                  })
                }
                iconPosition={PILL_ICON_POSITION.AFTER}
                text={name}
                count={count}
                selected={count > 0}
              />
            </div>
          );
        })}
      </div>
    );
  }
);

FilterPills.displayName = "FilterPills";
